<template>
  <form action="" class="registration-page__form" @submit.prevent="onSubmit">
    <errorMessages v-for="error in errors.all()" v-bind:key="error.id" v-bind:error="error"/>

    <div class="registration__left-field">
      <div class="registration-page__radio">
        <label for="typePrivate">
          <input type="radio" id="typePrivate" v-validate="'required'" name="type" value="PRIVATE" v-model="user.type" :data-vv-as="locale.register.type" />
          <span class="registration-page__radio-field"></span>
          <span class="registration-page__radio-text">{{locale.register.typePrivate}}</span>
        </label>
      </div>
      <div class="registration-page__radio">
        <label for="typeBusiness">
          <input type="radio" id="typeBusiness" v-validate="'required'" name="type" value="BUSINESS" v-model="user.type" :data-vv-as="locale.register.type" />
          <span class="registration-page__radio-field"></span>
          <span class="registration-page__radio-text">{{locale.register.typeBusiness}}</span>
        </label>
      </div>
    </div>

    <div v-if="user.type === 'BUSINESS'">
      <div class="registration-page__left-field">
        <label for="company">{{locale.register.company}}</label>
        <input type="text" :placeholder="locale.register.company" v-validate="'required|min:5'" :data-vv-as="locale.register.company" name="company" v-model="user.company">
      </div>
      <div class="registration-page__right-field">
        <label for="companyVatID">{{locale.register.companyVatID}}</label>
        <input type="text" :placeholder="locale.register.companyVatID" v-validate="'required|min:5'" :data-vv-as="locale.register.companyVatID" name="companyVatID" v-model="user.companyVatID">
      </div>
    </div>
    <div class="registration-page__left-field">
      <label for="firstname">{{locale.register.firstname}}</label>
      <input type="text" :placeholder="locale.register.firstname" v-validate="'required|alpha_num|min:3'" :data-vv-as="locale.register.firstname" name="firstName" v-model="user.firstName">
    </div>
    <div class="registration-page__right-field">
      <label for="lastname">{{locale.register.lastname}}</label>
      <input type="text" :placeholder="locale.register.lastname" v-validate="'required|alpha_num|min:3'" :data-vv-as="locale.register.lastname" name="lastName" v-model="user.lastName">
    </div>
    <div v-if="user.type === 'PRIVATE'">
      <div class="registration-page__left-field">
        <label for="birthday">{{locale.register.birthday}}</label>
        <input type="text" :placeholder="locale.register.birthday" v-validate="'date_format:DD.MM.YYYY'" :data-vv-as="locale.register.birthday" name="birthday" v-model="user.birthday">
      </div>
    </div>

    <div class="registration-page__left-field">
      <label for="email">{{locale.register.email}}</label>
      <input type="email" :placeholder="locale.register.email" v-validate="'required|email'" :data-vv-as="locale.register.email" name="email" v-model="user.email">
    </div>

    <div class="registration-page__right-field">
      <label for="emailBilling">{{locale.register.emailBilling}}</label>
      <input type="email" :placeholder="locale.register.emailBilling" v-validate="'required|email'" :data-vv-as="locale.register.emailBilling" name="emailBilling" v-model="user.emailBilling">
    </div>

    <div class="registration-page__left-field">
      <label for="street">{{locale.register.street}}</label>
      <input type="text" :placeholder="locale.register.street" v-validate="'required|min:5'" :data-vv-as="locale.register.street" name="street" v-model="user.street">
    </div>

    <div class="registration-page__right-field">
      <label for="houseNumber">{{locale.register.houseNumber}}</label>
      <input type="text" :placeholder="locale.register.houseNumber" v-validate="'required'" :data-vv-as="locale.register.houseNumber" name="houseNumber" v-model="user.houseNumber">
    </div>

    <div class="registration-page__left-field">
      <label for="zip">{{locale.register.zip}}</label>
      <input type="number" :placeholder="locale.register.zip" v-validate="'required|alpha_num|min:4'" :data-vv-as="locale.register.zip" name="zip" v-model="user.zipCode">
    </div>

    <div class="registration-page__right-field">
      <label for="city">{{locale.register.city}}</label>
      <input type="text" :placeholder="locale.register.city" v-validate="'required|alpha_num|min:3'" :data-vv-as="locale.register.city" name="city" v-model="user.city">
    </div>

    <div class="registration-page__left-field">
      <label for="country">{{locale.register.country}}</label>
      <select autocomplete="off" id="country" v-validate="{ required: true }" :data-vv-as="locale.register.country" name="country" v-model="user.country" required>
<!--        <option disabled selected value="">{{locale.register.country}}</option>-->
        <option selected value="DE">Deutschland</option>
      </select>
    </div>

    <div class="registration-page__left-field">
      <label for="tel">{{locale.register.phone}}</label>
      <input type="text" :placeholder="locale.register.phone" v-validate="{ required: true, regex: /^[\s\d]+$/ }" :data-vv-as="locale.register.phone" name="tel" v-model="user.tel">
    </div>

    <div class="registration-page__right-field">
      <label for="mobile">{{locale.register.mobile}}</label>
      <input type="text" :placeholder="locale.register.mobile" v-validate="{ required: true, regex: /^[\s\d]+$/ }" :data-vv-as="locale.register.mobile" name="mobile" v-model="user.mobile">
    </div>

    <div class="registration-page__left-field">
      <vue-recaptcha :sitekey="grecaptcha_key" @verify="markRecaptchaAsVerified" size=1 ref="recaptcha">
      </vue-recaptcha>
    </div>

    <div class="registration-page__right-field registration-page__submit-button-wrapper">
      <button type="submit" class="button">{{locale.register.buttonText}}</button>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex'
import errorMessages from '../utils/errorMessages.vue'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'RegisterForm',
  components: { errorMessages, VueRecaptcha },
  computed: mapState([
    'locale'
  ]),
  data: function () {
    return {
      user: [],
      recaptchaVerified: null,
      grecaptcha_key: process.env.GOOGLE_RECAPTCHA_PUBLIC
    }
  },
  mounted () {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
    document.head.appendChild(recaptchaScript)
  },
  created () {
    this.$emit('activeStep', 0)
  },
  methods: {
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        if ((result) && (this.recaptchaVerified)) {
          this.$store.dispatch('user/registerUser', this.user).then((response) => {
            if (response.status === 200) {
              this.$emit('responseData', response.data)
              this.$router.push({ name: 'RegisterPayment' })
            }
          })
        }
      })
    },
    markRecaptchaAsVerified (response) {
      this.recaptchaVerified = true
      this.user.captcha = response
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RegisterForm.vue